'use client';
/** 광고 구매 단계 계측 — 기존 수집 경로(lib/analytics track → /api/analytics/events → user_events)를 그대로 쓴다. 단계는 화면을 연 동안 한 번만. */
import { track } from '@/lib/analytics';
import { ADS_FUNNEL_EVENT, cleanFunnelProps, type AdsFunnelStep } from '@/lib/ads/funnel';

const sent = new Set<string>();

/** 계측 실패가 화면 흐름을 막지 않는다. again=true 면 같은 단계라도 다시 남긴다(예: 결제 실패가 여러 번). */
export function trackAdsFunnel(step: AdsFunnelStep, props?: Record<string, unknown>, again = false): void {
  if (!again && sent.has(step)) return;
  sent.add(step);
  try { track(ADS_FUNNEL_EVENT, step, cleanFunnelProps(props)); } catch { /* 계측 실패 무시 */ }
}
